module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "tab-pane-plan-wrapper"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (!_vm.Access) ? [_c('div', {
    staticClass: "text-center margin-top-5"
  }, [(_vm.serviceStatus && (_vm.serviceStatus.loader || _vm.serviceStatus.timer)) ? _c('div', {
    staticStyle: {
      "margin": "80px auto"
    }
  }, [(_vm.serviceStatus['loader']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": require("../../assets/img/loading-hor16.gif")
    }
  })]) : (_vm.serviceStatus['timer']) ? _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])) + " "), _c('font-awesome-icon', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "icon": "clock"
    }
  })], 1) : _c('span', {
    staticClass: "margin-right-10 font-weight-500 font-size-120",
    class: 'w5-status-color-' + _vm.status
  }, [_vm._v(_vm._s(_vm._f("capitalize")(_vm.serviceStatus['status'])))])]) : [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": require("../../assets/img/puzzle.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])]], 2)] : [_c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/vnc_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/vnc_button_description')),
      expression: "localeFtc('service/vnc_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-access-tab"
  }, [_c('div', {
    staticClass: "w5-access-tab-label"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/password')) + ": ")]), _vm._v(" "), _c('div', {
    ref: "passwordRef",
    staticClass: "w5-access-tab-value",
    style: (_vm.isDataShown ? 'color: black' : false),
    attrs: {
      "id": "shownPassword"
    }
  }, [_vm._v(_vm._s(_vm.passwordForShow))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isDataShown),
      expression: "!isDataShown"
    }],
    staticClass: "w5-access-tab-button"
  }, [_c('font-awesome-icon', {
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active'
    },
    attrs: {
      "icon": "eye",
      "title": _vm._f("ftc")('main/show_data')
    },
    on: {
      "click": _vm.showPassword
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataShown && _vm.passwordForShow),
      expression: "isDataShown && passwordForShow"
    }],
    staticClass: "w5-access-tab-button"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "copy",
      "title": _vm._f("ftc")('main/copy_to_clipboard')
    },
    on: {
      "click": _vm.copyPassword
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataShown),
      expression: "isDataShown"
    }],
    staticClass: "w5-access-tab"
  }, [_c('div', {
    staticClass: "w5-access-tab-label"
  }, [_vm._v(_vm._s(_vm._f("ftc")('server/server')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "w5-access-tab-value",
    style: (_vm.isDataShown ? 'color: black' : false),
    attrs: {
      "id": "shownHost"
    }
  }, [_vm._v(_vm._s(_vm.hostForShow))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDataShown),
      expression: "isDataShown"
    }],
    staticClass: "w5-access-tab"
  }, [_c('div', {
    staticClass: "w5-access-tab-label"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/port VNC')) + ": ")]), _vm._v(" "), _c('div', {
    staticClass: "w5-access-tab-value",
    style: (_vm.isDataShown ? 'color: black' : false),
    attrs: {
      "id": "shownPort"
    }
  }, [_vm._v(_vm._s(_vm.portForShow))])]), _vm._v(" "), _c('div', {
    staticClass: "hidden-xs margin-top-10"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active'
    },
    on: {
      "click": _vm.vnc
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "terminal"
    }
  }), _vm._v("\r\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/vnc')) + "\r\n\t\t\t\t")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane-command-wrapper"
  }, [_c('h4', [_vm._v(_vm._s(_vm._f("ftc")('service/password_change_button_header')))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/password_change_button_description')),
      expression: "localeFtc('service/password_change_button_description')"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "btns-block"
  }, [_c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || !_vm.passwordType || !_vm.passwordType.vnc
    },
    on: {
      "click": function($event) {
        return _vm.changePassword('vnc')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "random"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/password_change')) + " VNC\r\n\t\t\t\t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "btn btn-submit tab-command-button",
    class: {
      'disable': !_vm.Access || _vm.Status !== 'active' || !_vm.passwordType || !_vm.passwordType.root
    },
    on: {
      "click": function($event) {
        return _vm.changePassword('root')
      }
    }
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "random"
    }
  }), _vm._v("\r\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/password_change')) + " root\r\n\t\t\t\t\t")], 1)])])]], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPasswordModal),
      expression: "showPasswordModal"
    }],
    staticClass: "modal-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hidePasswordModal(false); }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePasswordModal
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')) + " " + _vm._s(String(_vm.passwordTypeSelected).toUpperCase()))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.passwordWarning) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.passwordWarning)),
      expression: "localeFtc(passwordWarning)"
    }],
    staticClass: "alert alert-warning font-size-90 margin-0 full-width"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": "vds",
      "action": "view",
      "Field": _vm.passwordField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.onFocusPassword,
      "enterKeyDown": _vm.passwordChange
    },
    model: {
      value: (_vm.passwordValue),
      callback: function($$v) {
        _vm.passwordValue = $$v
      },
      expression: "passwordValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.passwordChange
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/password_change')))])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ee0ebd7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vds/access.vue
// module id = 560
// module chunks = 0